// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"462":"53809e14","793":"e96ca2ba","983":"c17094af","987":"87350f37"}[chunkId] + ".chunk.css";
};